import styled from 'styled-components';

export const Container = styled.div`
  min-width: 1107px;
  padding: 32px;
  > .ant-menu {
    margin-bottom: 16px;
  }
`;
